import UrlUtils from '../../../../utils/url';
import ApiUtils from '../../../../utils/api';
import { Api } from '../../../../typings/api';

export const getModifiedCss = (galleryConfig: Api.Config, css: string, resourceId: number): string => {
	const urlRegExp = /url\((['"]?)(.+?)\1\)/g;

	// replace relative urls from inDesign css file to absolute urls
	const modifiedCss = css.replace(urlRegExp, (match, quote, relPath) => {
		const url = UrlUtils.getEditorResourceUrl(galleryConfig, resourceId, relPath);
		return `url("${url}?token=${ApiUtils.token}&preventRedirect=true")`;
	});

	return modifiedCss;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/css.ts